<section class="card shadow-sm-darker">
  <div class="card-body d-flex justify-content-between align-items-center">
    <div>
      <h3>{{assessmentname}}</h3>
      <p class="text-sm mb-0"><span>{{timedType}} / {{questionType}}</span><br>
        <span><span class="font-weight-600">Start:</span> {{startTime}}</span><br>
        <span><span class="font-weight-600">Due:</span> {{endTime}}</span>        
      </p>
    </div>
    <div>
      <button *ngIf="assessment.allowRetake" class="add-item-btn" (click)="togglepopup()">
        Retake Assessment
      </button>
    </div>
  </div>
  <ng-template [ngIf]="scored">
    <div style="margin: 0px auto;">
      <span><span class="font-weight-600">Score:</span> {{score}} / {{marks}}</span>
    </div>
  </ng-template>
</section>
<form #questionanswers="ngForm" name="questionanswers" class="card shadow-sm-darker mb-0">
  <section *ngIf="this.showClock" #clock class="card-header text-center">
    <h4 class="card-title text-uppercase mb-2"> Time Remaining : </h4>
    <time class="text-lg font-weight-bold clock warningClock" [ngStyle]="{visibility: !this.clockReady ? 'hidden' : ''}">0h 0m 0s</time>
  </section>
  <div class="card-body">
    <ul class="list-unstyled m-0" #questionPane>
      <li *ngFor="let question of this.questions; let optionGroupIndex = index">
        <div class="std-qst">
          <h4 class="text-xs mb-3"><span class="text-primary-darker">QUESTION {{optionGroupIndex + 1}}</span>
            of {{this.assessment.questions.length}} ({{question.marks}} mark{{question.marks === 1 ? '' : 's'}})
          </h4>
          <div class="inlineOptions innerHTML-wrap" [innerHTML]="question.text | customhtmlsanitizer">
          </div>
          <div
            *ngIf="this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.essayQuestionFlag && !this.assessment.submitted"
            class="mt-3">
            <app-assessment-editor [answeredText]="question.stdAnswer" [questionID]="question.id" [wordLimit]="assessment.essayTextLimit" (textLimitExceeded)="handleTextExceeded($event)">
            </app-assessment-editor>
          </div>
          <section
            *ngIf="this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.essayQuestionFlag && this.assessment.submitted"
            class="mt-3">
            <h4 class="text-uppercase">Submission</h4>
            <div class="card shadow-sm-darker mb-3" [answeredText]="question.stdAnswer" [questionID]="question.id">
              <div [innerHTML]="question.stdAnswer" class="card-body"></div>
            </div>
          </section>
          <div *ngIf="this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.fileQuestionFlag"
            class="mt-3">
            <div *ngIf="!this.assessment.submitted">
              <p class="text-center text-sm">{{submissionFileName || 'No File Selected'}}</p>
              <button (click)="fileUpload.click()" type="button" id="fileUploadLabel"
                class="btn m-auto">Select File</button>
              <input type="file" required #fileUpload class="sr-only" id="{{question.id}}" name="file"
                aria-labelledby="fileUploadLabel" (change)="handleFileSelect($event.target.files)">
            </div>
            <div *ngIf="this.fileQuestionDisplay">
              <h4 class="text-uppercase">{{this.isDraft ? "Uploaded Draft" : "Submitted/Uploaded File"}}</h4>
              <p class="text-sm mb-0"><a target="_blank" href="{{fileQuestionDisplay.link}}" class="text-link" download><i
                    class="fa fa-download mr-2"></i>{{this.fileQuestionDisplay.name}}</a></p>
            </div>
          </div>
          <div class="mt-3" *ngIf="question.comment && this.assessment.questionType != this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag">
            <h4 class="font-weight-500 text-uppercase">Tutor's Comment:</h4><span class="text-sm">"{{question.comment}}"</span>
          </div>
          <div class="mt-3" *ngIf="question.score >= 0 && this.assessment.scored && this.assessment.submitted && this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.essayQuestionFlag">
            <h4 class="font-weight-500 text-uppercase">Question Score:</h4><span class="text-sm">{{question.score}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="card-footer text-center" #buttonPane>
    <div *ngIf="questionCount > 1" class="d-flex flex-wrap gap-1.5 mb-4"
      [ngClass]="{'justify-content-start': hideQuestionNavButton !== 2 && questionCount > 1, 'justify-content-between': hideQuestionNavButton !== 2 && questionCount > 1 && hideQuestionNavButton !== 1, 'justify-content-end': hideQuestionNavButton !== 1 }">
      <button type="button" class="btn btn--sm m-0" *ngIf="hideQuestionNavButton !== 2 && questionCount > 1"
        (click)="getQuestionToShow(questionInView.previous)"><i
          class="fa fa-angle-left"></i><span>Previous</span></button>
      <button type="button" class="btn btn--sm m-0" *ngIf="hideQuestionNavButton !== 1"
        (click)="getQuestionToShow(questionInView.next)"><span>Next</span><i class="fa fa-angle-right"></i></button>
    </div>
    <div class="mb-4" *ngIf="this.questions && this.questions.length > 1">
      <button type="button" class="badge badge-lg border-0 m-2 questionBadge" (click)="getQuestionToShow(badgeIndex)"
        *ngFor="let question of this.questions; let badgeIndex = index"  [ngClass]="{'red-color': question.isValid === 0}">{{badgeIndex + 1}}</button>
    </div>
    <div class="d-flex justify-content-center flex-wrap gap-1.5">
      <button type="submit" class="add-item-btn text-uppercase" [disabled]="!questionanswers.valid" (click)="saveAssessment(true)"
        *ngIf="assessment && assessment.draft && showsubmit && this.assessment.questionType != this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag">
        <i class="fas fa-save"></i> Save Draft
      </button>
      <button type="submit" class="btn m-0" id="submit" [disabled]="!questionanswers.valid" (click)="saveAssessment()"
        *ngIf="assessment && assessment.draft && showsubmit">Submit</button>
      <button type="button" class="btn btn--warning m-0" id="cancel" routerLink="/user/assessmentconsole"
        *ngIf="this.classID" [queryParams]="{classid : this.classID,batchid:this.batchID}">Cancel</button>
    </div>
  </div>
</form>
